<template>
<div class="exam-list-container">
  <!-- <div class="exam-oprate-wrap">
    <el-button :disabled="true" class="trade-button">发布作业</el-button>
  </div> -->
  <div v-if="homeworkList.length>0" class="exam-list-wrap">
    <div v-for="(homework,homeworkIndex) in homeworkList" :key="homeworkIndex" class="exam-item">
      <div class="exam-info-wrap">
        <div class="exam-info">
          <div class="exam-name">
            {{`${homework.subjectName}-${homework.className}`}}
            <div class="exam-type">
              <el-tag
                :type="getTagType(homework.status)">
                {{homework.statusName}}
              </el-tag>
            </div>
          </div>
          <div class="exam-date">
            {{homework.createTime}}
          </div>
        </div>
        <div  v-if="homework.enableManageExam" class="exam-oprate">
          <el-button @click="showUploadDialog(homework)" style="height:30px;" icon="el-icon-document-add" size="mini">上传学生作业</el-button>
          <el-button @click="showUploadView(homework)"  style="height:30px;" icon="el-icon-view" size="mini">查看识别错误</el-button>
           <!-- <div style="border-left:1px solid #e6dddd;height:30px;margin-left:20px;width:15px;"></div>
          <i v-if="managerRole" @click="editExam(examInfo)" class="iconfont icon-banshou oprate-edit"></i>
          <i v-if="managerRole" @click="deleteExam(examInfo)" class="el-icon-delete oprate-delete"></i>
          <router-link class="el-icon-data-analysis oprate-knowledge-point" tag="i" :to="`exam/${examInfo.examId}/${examInfo.examName}/item-knowledge-points/1/1/`"></router-link> -->
        </div>
      </div>
    </div>
  </div>
  <div v-else class="no-exam-wrap">
    暂无作业信息
  </div>
  <upload-homework-dialog :taskId="operateHomework.taskId" :dialogVisible="uploadDialogVisible" @dialog-close="handleUploadClose" />
</div>
</template>

<script>

import {listClassWork} from '@/model/homework-model'
import common from '../../../util/common'
import UploadHomeworkDialog from './UploadHomeworkDialog'

export default {
  data () {
    return {
      homeworkList: [],
      operateHomework: {},
      uploadDialogVisible: false,
      submitLoading: false
    }
  },
  props: {
    userInfo: {
      type: Object,
      required: true,
      default: ''
    }
  },
  computed: {
    managerRole () {
      return ['2', '4'].includes(this.userInfo.role)
    },
    orgId () {
      return this.userInfo.origanization
    },
    orgIsSchool () {
      return common.translateOrgType(this.userInfo.organization.type) === '学校'
    },
    roleType () {
      return common.systemRoleEnum
    }
  },
  components: {
    UploadHomeworkDialog
  },
  methods: {
    getTagType(status){
      if (status === 1) {
        return ''
      } else if (status === 2) {
        return 'warning'
      } else {
        return 'success'
      }
    },
    showUploadDialog (homework) {
      this.operateHomework = homework
      this.uploadDialogVisible = true
    },
    handleUploadClose (done) {
      this.uploadDialogVisible = false
    },
    getStatusName (status) {
      if (status === 1) {
        return '未开始批阅'
      } else if (status === 2) {
        return '批阅中'
      } else {
        return '批阅完成'
      }
    },
    showUploadView (homework) {
      this.$router.push({ path: `upload-view/${homework.taskId}` })
    },
    editExam (examInfo) {
      if (this.orgIsSchool) {
        this.$router.push({ path: `exam-school/edit/${examInfo.examId}` })
      } else {
        this.$router.push({ path: `exam/edit/${examInfo.examId}` })
      }
    },
    deleteExam (examInfo) {
      this.componentName = 'ExamDelete'
      this.oprateExamId = examInfo.examId
      this.dialogVisible = true
    },
    checkExamRole (examInfo) {
      let isManager = false
      let isOwnExam = false
      if (this.userInfo.role === common.systemRoleEnum.eduInfoManager ||
        this.userInfo.role === common.systemRoleEnum.schoolInfoManager ||
        this.userInfo.role === common.systemRoleEnum.researcher) {
        isManager = true
      }
      if (examInfo.orgId === this.orgId) {
        isOwnExam = true
      }
      return isManager && isOwnExam
    },
    readTask (examInfo, subjectInfo) {
      this.$router.push(`/exam/task-school/${examInfo.examId}/${subjectInfo.subjectId}`)
    },
    initHomeworkList (homeworkInfo) {
      this.homeworkList.splice(0, this.homeworkList.length)
      let homeworkObject = {}
      homeworkInfo.forEach((homework, index) => {
        homeworkObject = {
          ...homework,
          statusName: this.getStatusName(homework.status),
          enableManageExam: true
        }
        this.homeworkList.push(homeworkObject)
      })
    }
  },
  mounted () {
    listClassWork({
      data: {
        teacherId: '169274690961409'
      },
      pageNum: 1,
      pageSize: 1000
    }).then((result) => {
      if (result.result.toString() === 'true') {
        this.initHomeworkList(result.data)
      }
    })
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.exam-list-container {
  $container-height:calc(100vh - 123px - 50px);
  $exam-list-height:calc(100vh - 118px - 125px);
  width: 100%;
  height: $container-height;
  background: white;
  overflow: hidden;
  .trade-button {
    background: #55C872;
    border-color: #55C872;
    color: #fff;
    cursor: pointer;
    box-shadow: 0px 0px 6px #55c872;
    &:hover{
      box-shadow: 0px 0px 20px #55c872;
    }
  }
  .exam-oprate-wrap{
    height: 40px;
  }
  .exam-list-wrap{
    margin-top: 20px;
    height:  $exam-list-height;
    overflow-y: auto;
    padding-top: 2px;
    padding-left: 2px;
    padding-right: 2px;
    padding-bottom: 5px;
    display: flex;
    flex-direction: column;
    .exam-item{
      box-shadow: 0 0 4px 0 $color-off;
      border-radius: 3px;
      display: flex;
      flex-direction: column;
      padding:25px;
      background-color: white;
      &:nth-child(n+2){
        margin-top: 25px;
      }
      .exam-info-wrap{
        display: flex;
        min-height: 39px;
        padding-bottom: 5px;
        .exam-info{
          border-left: solid 10px $color-primary;
          display: flex;
          justify-content: center;
          width: 100%;
          flex-direction: column;
          height: 39px;
          .exam-name{
            display: flex;
            height: 50%;
            margin-left: 10px;
            font-size: 15px;
            color:$color-text;
          }
          .exam-type{
            margin-left: 10px;
            border-radius: 4px;
            height: 100%;
            display: flex;
            justify-content: center;
            transform: scale(0.9);
          }
          .exam-date{
            height: 50%;
            margin-left: 10px;
            display: flex;
            font-size: 12px;
            color: $color-text-hui;
          }
        }
        .exam-oprate{
          min-width: 330px;
          display: flex;
          justify-content: center;
          align-items: center;
          .oprate-delete{
            margin-left: 15px;
            font-size: 20px;
            color: $color-text-hui;
            cursor: pointer;
            font-weight: bolder;
            &:hover{
              color: $color-danger;
            }
          }
          .oprate-edit{
            font-size: 20px;
            color: $color-text-hui;
            cursor: pointer;
            font-weight: bolder;
            &:hover{
              color: $color-primary;
            }
          }
          .oprate-knowledge-point{
            display: none;
            margin-left: 15px;
            font-size: 20px;
            color: $color-text-hui;
            cursor: pointer;
            font-weight: bolder;
            &:hover{
              color: $color-success;
            }
          }
        }
      }
      .bottom-wrap{
        display: flex;
        min-height: 45px;
        border-top: 1px solid #e6dddd;
        justify-content: center;
        .button-hide{
          border: 1px solid #e6dddd;
          width: 30px;
          height: 30px;
          border-radius: 50%;
          margin-top: -16px;
          background: #f7f7f4;
          display: flex;
          justify-content: center;
          align-items: center;
          transform: rotate(90deg);
          cursor: pointer;
          transition: transform .3s;
          &:hover{
            box-shadow: 0px 0px 4px 0px #94918f;
            border: 1px solid $color-primary;
            background: $color-primary;
          }
          .botton-hide-icon{
            font-size: 16px;
            font-weight: bold;
            color: #73390c;
            &:hover{
              color: white;
            }
          }
        }
        .is-active{
          transform: rotate(-90deg);
        }
      }
    }

  }
  .no-exam-wrap{
    height:  $exam-list-height;
    overflow-y: auto;
    padding-top: 2px;
    padding-left: 2px;
    padding-right: 2px;
    padding-bottom: 5px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
}
// 上传窗口
</style>



// WEBPACK FOOTER //
// src/views/home-work/work/WorkList.vue